import _ from 'lodash';
import { combineReducers } from 'redux';
import { toggleReducer } from 'frontend/state/utils';
import types from 'frontend/state/actionTypes';

const customAplsReducer = (state = [], action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_CUSTOM_APL: {
      const { className, spec, apl } = payload;
      return [
        ..._.reject(state, { className, spec }),
        {
          className,
          spec,
          apl,
        },
      ];
    }
    case types.CLEAR_CUSTOM_APL: {
      const { className, spec } = payload;
      return _.reject(state, { className, spec });
    }
    default:
      return state;
  }
};

export default combineReducers({
  customApls: customAplsReducer,
  open: toggleReducer({
    toggle: types.TOGGLE_CUSTOM_APLS,
    initial: false,
  }),
});

const baseSelector = state => state.simbot.customApls;
const customAplsSelector = state => baseSelector(state).customApls;
const openSelector = state => baseSelector(state).open;

export const selectors = {
  customApls: customAplsSelector,
  open: openSelector,
};
